<div class="visualizar-formulario-container">
  <div class="header">
    <div>
      <h1>Visualizar Formulário</h1>
      <p class="subtitle">Dados preenchidos do atendimento</p>
    </div>
    <button class="btn btn-outline-secondary" (click)="voltar()">
      <i class="fa fa-arrow-left"></i> Voltar
    </button>
  </div>

  <div class="card-box" *ngIf="!loading && secoes.length === 0">
    <p class="empty-message mb-0">Nenhum dado de formulário encontrado para esta consulta.</p>
  </div>

  <div class="card-box" *ngFor="let secao of secoes">
    <h5 class="secao-titulo">{{ secao.titulo }}</h5>
    <div class="table-responsive">
      <table class="table table-sm table-hover mb-0">
        <thead>
          <tr>
            <th style="width: 32%;">Campo</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let campo of secao.campos">
            <td class="campo">{{ campo.chave }}</td>
            <td>{{ campo.valor }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
